import { navigation } from '../app/navigation.js';
import { HTMLControl } from '../controls/html_control.js';
import { Picture } from '../data/picture.js';
import { listenToEvent } from '../util/listen_to_event.js';
import { window } from '../window.js';

import '../components/avatar_list.js';
import './trip_menu_control.js';

class TripBadge extends HTMLControl {
  static selectors = {
    Cocampers: 'avatar-list',
    Date: '.trip-date',
    Duration: '.trip-duration',
    Ico: '.trip-ico',
    Loc: '.trip-loc > span',
    Menu: 'trip-menu-control',
    Title: '.listname',
  };

  static elements = {
    cocampersElement: this.selectors.Cocampers,
    dateElement: this.selectors.Date,
    durationElement: this.selectors.Duration,
    icoElement: this.selectors.Ico,
    locElement: this.selectors.Loc,
    menuElement: this.selectors.Menu,
    titleElement: this.selectors.Title,
  };

  static properties = {
    friends: {
      set(v) {
        this.cocampersElement.friends = v;
      },
    },
    setTripId(v) {
      this.setAttribute('trip-id', v);
    },
    setTitle(v) {
      this.titleElement.textContent = v;
    },
    setDuration(v) {
      let duration = v > 1 ? `${v} days` : `${v} day`;
      this.durationElement.textContent = duration;
    },
    setStartDate(v) {
      // Use UTC timezone for formatting because the given date has no time and
      // has zero offset timezone. new Date() will use a local
      // timezone to parse the date, which when formatted may result in a wrong
      // date returned.
      let date = new Date(v);
      let formattedDate = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'long',
        timeZone: 'UTC',
      }).format(date);
      this.dateElement.textContent = formattedDate;
    },
    setLoc(v) {
      this.locElement.textContent = v.name;
    },
    setCover(v) {
      this.icoElement.src =
        (v && Picture.getThumbnailUrl(v)) || Picture.defaultThumbnailPicUrl;
    },
    setCocampers(v) {
      this.cocampersElement.set(v);
    },
    setMenu(v) {
      this.menuElement.setData(v);
    },
  };

  get tripId() {
    return (this.#trip && this.#trip.id) || 0;
  }

  get current() {
    return this.hasAttribute('current');
  }
  set current(v) {
    v
      ? this.setAttribute('current', 'current')
      : this.removeAttribute('current');
  }

  async set(trip) {
    this.#trip?.unpipe(this.#dataMap);
    this.#trip = trip;
    this.#trip.pipe(this.#dataMap);

    this.setMenu(trip);
  }

  initialize() {
    super.initialize();

    this.classList.add('trip');
    this.setAttribute('tabindex', 0);

    listenToEvent(this, 'focus', () =>
      navigation.tripPlanning.switchTo(this.#trip)
    );
    listenToEvent(this.titleElement, 'click', () => navigation.toTrip());
    listenToEvent(this.icoElement, 'click', () => navigation.toTrip());
  }

  static markup = `
    <div class='trip-body'>
      <img class='trip-ico'>
      <div class='trip-data'>
        <div class='trip-date'></div>
        <div class='trip-duration'></div>
        <avatar-list></avatar-list>
      </div>
      <trip-menu-control class='trip-menu'></trip-menu-control>
    </div>
    <div class='trip-title'>
      <div class='trip-name'>
        <span class='listname'></span>
      </div>
      <div class='trip-loc'>at <span></span></div>
    </div>
  `;

  #dataMap = {
    id: v => this.setTripId(v),
    title: v => this.setTitle(v),
    duration: v => this.setDuration(v),
    startDate: v => this.setStartDate(v),
    loc: v => this.setLoc(v),
    cover: v => this.setCover(v),
    cocampers: v => this.setCocampers(v),
  };

  #trip;
}

window.customElements.define('trip-badge', TripBadge);

export { TripBadge };
